<app-client-details-navigation *ngIf="currentItem" [clientID]="currentItem.ClientID" ></app-client-details-navigation>

<div class="main-page-content">
  <div class="main-page-content-block" *ngIf="currentItem">
    <h2>AI Usage Limits</h2>
    <p class="alert alert-info">
      Limits are shared across all AI use in this company. Leave a field blank to block AI use for that period. Enter 0 for unlimited use.
    </p>

    <div class="row">
      <div class="col-lg-4 mb-3">
        <label for="DailyUsdLimit">Daily USD limit</label>
        <input id="DailyUsdLimit" name="DailyUsdLimit" type="number" min="0" step="0.01" class="form-control"
               [(ngModel)]="currentItem.DailyUsdLimit" />
      </div>
      <div class="col-lg-4 mb-3">
        <label for="WeeklyUsdLimit">Weekly USD limit</label>
        <input id="WeeklyUsdLimit" name="WeeklyUsdLimit" type="number" min="0" step="0.01" class="form-control"
               [(ngModel)]="currentItem.WeeklyUsdLimit" />
      </div>
      <div class="col-lg-4 mb-3">
        <label for="MonthlyUsdLimit">Monthly USD limit</label>
        <input id="MonthlyUsdLimit" name="MonthlyUsdLimit" type="number" min="0" step="0.01" class="form-control"
               [(ngModel)]="currentItem.MonthlyUsdLimit" />
      </div>
    </div>

    <h3>Feature Models</h3>
    <p class="text-muted">
      Choose which priced models each feature can use. If no models are enabled for a feature, users will not see that feature.
    </p>
    <p class="alert alert-warning" *ngIf="hasModelsNeedingGlobalPricing()">
      Some models are unavailable because global input and output pricing has not been configured.
      <a [routerLink]="aiModelPricingLink">Open AI Model Pricing</a> to set prices before enabling models here.
    </p>

    <div class="mb-4" *ngFor="let feature of currentItem.Features || []">
      <div class="d-flex justify-content-between align-items-center flex-wrap mb-2">
        <h4 class="mb-2">{{ feature.DisplayName }}</h4>
        <div class="form-inline mb-2" *ngIf="getAllowedModels(feature).length > 0">
          <label class="mr-2" [for]="'DefaultModel_' + feature.Feature">Default model</label>
          <select class="form-control form-control-sm"
                  [id]="'DefaultModel_' + feature.Feature"
                  [name]="'DefaultModel_' + feature.Feature"
                  [(ngModel)]="feature.DefaultModelID">
            <option *ngFor="let model of getAllowedModels(feature)" [ngValue]="model.ModelID">
              {{ model.DisplayName }}
            </option>
          </select>
        </div>
      </div>
      <div class="table-responsive mb-2">
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th>Model</th>
              <th>Input price per 1M tokens</th>
              <th>Output price per 1M tokens</th>
              <th>Available</th>
              <th>Use for feature</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let model of feature.Models">
              <td>{{ model.DisplayName }}</td>
              <td>
                <span *ngIf="model.InputUsdPerMillionTokens !== null; else inputNotConfigured">
                  {{ model.InputUsdPerMillionTokens | currency:'USD':'symbol':'1.2-2' }}
                </span>
                <ng-template #inputNotConfigured>
                  <span class="text-muted">Not configured globally</span>
                </ng-template>
              </td>
              <td>
                <span *ngIf="model.OutputUsdPerMillionTokens !== null; else outputNotConfigured">
                  {{ model.OutputUsdPerMillionTokens | currency:'USD':'symbol':'1.2-2' }}
                </span>
                <ng-template #outputNotConfigured>
                  <span class="text-muted">Not configured globally</span>
                </ng-template>
              </td>
              <td>
                <span *ngIf="isModelAvailable(model); else unavailableModel">Yes</span>
                <ng-template #unavailableModel>
                  <span>No</span>
                  <span class="text-muted d-block small" *ngIf="!isGlobalPricingConfigured(model); else inactiveModel">
                    Global pricing is not set.
                    <a [routerLink]="aiModelPricingLink">Configure pricing</a>
                  </span>
                  <ng-template #inactiveModel>
                    <span class="text-muted d-block small">
                      Inactive in
                      <a [routerLink]="aiModelPricingLink">AI Model Pricing</a>.
                    </span>
                  </ng-template>
                </ng-template>
              </td>
              <td>
                <input type="checkbox"
                       [name]="'AllowedFeatureModel_' + feature.Feature + '_' + model.ModelID"
                       [(ngModel)]="model.Allowed"
                       (ngModelChange)="onFeatureModelAllowedChange(feature)"
                       [disabled]="!isModelAvailable(model)" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="text-muted mb-0" *ngIf="getAllowedModels(feature).length === 0">
        This feature is disabled for users.
        <span *ngIf="hasModelsNeedingGlobalPricing()">
          Configure global model pricing on the
          <a [routerLink]="aiModelPricingLink">AI Model Pricing</a> screen to enable models here.
        </span>
      </p>
    </div>

    <button class="btn btn-success" [class.button-loading]="loading" (click)="save()">Save</button>
  </div>
</div>
